<template>
    <div>
        <b-overlay
            :show="sub_layout_loading"
            rounded="sm"
            blur="0"
            opacity="0.5"
            z-index="9999"
        >
            <div id="campaign-container">
                <!-- 제목(프로젝트: 원청/프로젝트 코드 · 캠페인: 캠페인 이름) + 나가는 길 + 화면 안 탭 -->
                <!-- 진행현황 · 평가결과는 칸이 많은 표라 본문을 화면 폭(ds-top-body)으로 — 제목도 같은 세로선(contained 없이) -->
                <admin-page-header :title="sub_title" :back="{ label: '목록으로', onClick: goPrevList }">
                    <!-- 불러오는 중에는 탭을 막는다 — 전에는 로딩 막(b-overlay)이 탭까지 덮었는데, 제목 판은 이제 셸에 그려져 막 밖이다 -->
                    <template #tabs>
                        <router-link class="ds-ph-tab"
                                     :class="{ 'is-active': ['ProjectProgress', 'CampaignProgress'].includes($route.name), 'is-disabled': sub_layout_loading }"
                                     :aria-disabled="sub_layout_loading ? 'true' : null"
                                     :to="{ name: admin_mode === 'project' ? 'ProjectProgress' : 'CampaignProgress', query: nav_submenu_query }">
                            진행현황
                        </router-link>
                        <router-link class="ds-ph-tab" :class="{ 'is-active': $route.name === 'Answers', 'is-disabled': sub_layout_loading }"
                                     :aria-disabled="sub_layout_loading ? 'true' : null"
                                     :to="{ name: 'Answers', query: nav_submenu_query }">
                            기업별 답변
                        </router-link>
                        <router-link class="ds-ph-tab" :class="{ 'is-active': $route.name === 'CampaignReport', 'is-disabled': sub_layout_loading }"
                                     :aria-disabled="sub_layout_loading ? 'true' : null"
                                     :to="{ name: 'CampaignReport', query: nav_submenu_query }">
                            평가결과
                        </router-link>
                    </template>
                </admin-page-header>

                <div v-if="init_error" class="text-center py-5">
                    <div class="text-danger mb-3">{{ init_error }}</div>
                    <b-button variant="dark-border" size="sm" class="mr-2" @click="initData($route.path, null)">다시 시도</b-button>
                    <b-button size="sm" @click="goList">목록으로</b-button>
                </div>
                <router-view
                    v-else
                    :value_new="value_new"
                    :target_company_name="target_company_name"
                    :class="[is_printing === true ? 'px-5' : '', 'min-vh-100']"
                >
                </router-view>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'AdminSubLayout',
    components: {},
    props: {
        value_new: {
            default: false
        },
        target_company_name: {
            default: ''
        },
    },
    data() {
        return {
            sub_menu: [true, false, false, false],
            is_printing: false,
            // 목록에서 들어왔을 때의 목록 주소(기간·페이지·검색 유지). 새로고침·직접 진입이면 null
            list_return: null,
            init_error: '',
            register_menu: [true, false],
            operation_menu: [true, false],
            campaign_data: {
                project_code: null,
                campaign_id: null,
                template_code: null,
                client: null,
                company_name: null,
                campaign_name: null,
            },
        };
    },
    computed: {
        ...mapState(['admin_mode', 'is_admin', 'user_id']),
        ...mapState('admin', ['sub_layout_loading']),
        ...mapState('project_code', ['now_project', 'project_companies']),
        ...mapState('industry_campaigns', ['campaigns']),
        sub_title() {
            const d = this.campaign_data;
            if (this.admin_mode !== 'project') return d.campaign_name || '';
            return d.client || d.project_code ? `${d.client}/${d.project_code}` : '';
        },
        nav_submenu_query() {
            if (this.admin_mode === 'project') {
                return {
                    client: this.campaign_data.client,
                    pc: this.campaign_data.project_code,
                    cmp: this.campaign_data.campaign_id,
                    admin_mode: this.admin_mode
                };
            }
            if (this.admin_mode === 'camp') {
                return {
                    campaign_name: this.campaign_data.campaign_name,
                    cmp: this.campaign_data.campaign_id,
                    template_code: this.campaign_data.template_code,
                    admin_mode: this.admin_mode
                };
            }
            return null;
        }
    },
    beforeRouteEnter(to, from, next) {
        // 하위 탭끼리 이동할 때는 다시 불리지 않아 처음 들어온 목록 주소가 유지된다
        next(vm => {
            if (['ProjectCodeList', 'CampaignList'].includes(from.name)) {
                vm.list_return = {name: from.name, path: from.fullPath};
            }
        });
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(newRoute, oldRoute) {
                this.initData(newRoute, oldRoute);
            },
        }
    },
    created(){
        this.fetchAuditCategory();
    },
    methods: {
        ...mapActions('project_code', ['readSingleProjectCode', 'readSingleProjectCompaniesCampaign',]),
        ...mapActions('industry_campaigns', ['readSingleCampaignIndustries']),
        ...mapActions('admin', ['setLayoutLoading',]),
        ...mapMutations('project_code', ['update_project_companies', 'update_now_project']),
        ...mapMutations('industry_campaigns', ['update_campaigns_industries_list']),
        ...mapMutations('score', ['add_all_temp_target_companies']),
        ...mapMutations(['set_admin_mode']),
        ...mapActions('evaluations', ['fetchAuditCategory']),
        pageGo (destination) {
            this.$router.push(destination);
        },
        async setCampaignData(){
            const {client, cmp, pc, cpnm, admin_mode, template_code, campaign_name} = this.$route.query;
            /**
             * @description 쿼리 파라미터 유효성 검사
             * @type {boolean}
             */

            if(admin_mode == null){
                this.$router.push({name: 'ProjectCodeList', params: {urlError: true}});
                return;
            }
            if(admin_mode === 'project' && (pc == null )) {
                this.$router.push({name: 'ProjectCodeList', params: {urlError: true}});
                return;
            }
            if(admin_mode === 'camp' && (campaign_name == null || template_code == null || cmp == null) ) {
                this.$router.push({name: 'CampaignList', params: {urlError: true}});
                return;
            }
            
            await this.set_admin_mode(admin_mode);
             
            this.campaign_data = {
                campaign_id: cmp ?? this.$route.query.campaign_id,
                project_code: pc ?? this.$route.query.project_code,
                template_code: template_code,
                client: client ?? '',
                campaign_name: campaign_name ?? '',
                company_name: cpnm ?? this.$route.query.company_name,
            };
        },
        goList(){
            const name = this.admin_mode === 'project' ? 'ProjectCodeList' : 'CampaignList';
            this.$router.push(this.list_return?.name === name ? this.list_return.path : {name});
        },
        // 기업 답변 상세는 기업별 답변 목록으로, 나머지 탭은 프로젝트/캠페인 목록으로.
        // 상세는 진입 경로(기업별 답변·평가결과·AI 평가)가 여러 개라 '직전 화면'은 브라우저 뒤로가기에 맡긴다.
        goPrevList(){
            if (this.$route.name === 'CompanyAnswers') {
                this.$router.push({name: 'Answers', query: {...this.nav_submenu_query, q: this.$route.query.q}});
                return;
            }
            this.goList();
        },
        async initData(newRoute, oldRoute) {
            try {
                this.init_error = '';
                this.setLayoutLoading(true);
                
                if (oldRoute == null) {
                    await this.update_now_project({});
                    await this.update_project_companies([]);
                    await this.update_campaigns_industries_list([]);
                }
                await this.setCampaignData();
                
                if (this.admin_mode === 'project') {
                    if (this.now_project.project_code == null) {
                        await this.readSingleProjectCode({
                            project_code: this.campaign_data.project_code,
                            user_id: this.user_id
                        });
                    }
                
                    if ((this.project_companies?.length ?? 0) === 0) {
                        await this.readSingleProjectCompaniesCampaign({project_code: this.now_project.project_code }); // project_code에 해당하는 기업, 캠페인 불러오기
                        this.add_all_temp_target_companies(this.project_companies);
                        
                    }
                    
                    if (this.now_project.project_code == null) throw new Error('프로젝트 정보를 찾을 수 없습니다.');

                    if(this.campaign_data.client == null || this.campaign_data.client === '') {
                        this.campaign_data.client = this.now_project.client;

                        this.$router.push({
                            name: this.$route.name,
                            query: {
                                ...this.$route.query,
                                client: this.campaign_data.client,
                            }
                        });
                    }
                    return;
                }
                
                if (this.admin_mode === 'camp') {
                    if ((this.campaigns?.length ?? 0) === 0) {
                        await this.readSingleCampaignIndustries({user_id:this.user_id, campaign_id: this.campaign_data.campaign_id});
                        if ((this.campaigns?.length ?? 0) === 0) throw new Error('캠페인 정보를 찾을 수 없습니다.');
                        
                        this.add_all_temp_target_companies(this.campaigns[0].scoring_target_companies);
                        this.$store.commit('update_campaign', this.campaigns[0]);
                    }
                    
                    return;
                }
            }
            catch (e) {
                console.error(e);
                this.init_error = `${this.admin_mode === 'project' ? '프로젝트' : '캠페인'} 정보를 불러오지 못했습니다. 주소의 프로젝트/캠페인 값이 올바른지 확인하거나 다시 시도해 주세요.`;
            }
            finally {
                this.setLayoutLoading(false);
            }
           

        }

        /**
         * @todo 버튼 접근 권한 정리 필요.
         */
        // checkAllowed (campaign_state, campaign_type, user_admin_level, target_admin_level) {
        //     if (campaign_state === '평가중' || campaign_state === '결과배포' || campaign_state === '종료') return true;
        //     if (user_admin_level >= 4) return true;
        //     if (campaign_type === 'owner') return true;
        //     if (campaign_type === 'auditor' && user_admin_level < target_admin_level) {
        //         return false;
        //     } else {
        //         return true;
        //     }
        // },
    }
};
</script>

<style>
.arrow-line-up {
    border-top: 1px solid #ff00ff;
    height: 100px;
    margin-left: -140px;
    transform: rotate(45deg);
}

.arrow-line-down {
    border-top: 1px solid #ff00ff;
    height: 100px;
    margin-left: -140px;
    transform: rotate(135deg);
}

.arrow-line {
    position: relative;
    height: 100px;
}

.arrow-line::before {
    content: '';
    position: absolute;
    left: 100%;
    z-index: -1;
    width: 28px;
    height: 28px;
    border-right: 2px solid black;
    border-bottom: 2px solid black;
    transform: rotate(-45deg) translate(-14px, -7px);
}
</style>
